import { render, staticRenderFns } from "./TableRowHearingAidUnitsPerPatient.vue?vue&type=template&id=2238eef2&lang=pug&"
import script from "./TableRowHearingAidUnitsPerPatient.vue?vue&type=script&lang=js&"
export * from "./TableRowHearingAidUnitsPerPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2238eef2')) {
      api.createRecord('2238eef2', component.options)
    } else {
      api.reload('2238eef2', component.options)
    }
    module.hot.accept("./TableRowHearingAidUnitsPerPatient.vue?vue&type=template&id=2238eef2&lang=pug&", function () {
      api.rerender('2238eef2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/benchmarks/table-rows/monthly/TableRowHearingAidUnitsPerPatient.vue"
export default component.exports